import { render } from "./Buscador.vue?vue&type=template&id=6b934ed6"
import script from "./Buscador.vue?vue&type=script&lang=js"
export * from "./Buscador.vue?vue&type=script&lang=js"
script.render = render

export default script